import React from 'react';
import './PrivacyPolicyPage.scss';

const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy__container">
        <h1>Privacy Policy</h1>
        <p className="privacy-policy__last-updated">Last Updated: May 6, 2025</p>
        
        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to Tyrrst ("we," "our," or "us"). We are committed to protecting your privacy and personal data. 
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website
            and use our services.
          </p>
          <p>
            Please read this Privacy Policy carefully. If you do not agree with the terms of this Privacy Policy, 
            please do not access the site.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <h3>Personal Data</h3>
          <p>
            We may collect personal identification information from users in various ways, including, but not limited to, 
            when users visit our site, register on the site, place an order, subscribe to the newsletter, respond to a survey, 
            fill out a form, and in connection with other activities, services, features, or resources we make available on our site. 
            Users may be asked for, as appropriate:
          </p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Mailing address</li>
            <li>Phone number</li>
            <li>Payment information</li>
            <li>Company information</li>
          </ul>

          <h3>Non-Personal Data</h3>
          <p>
            We may collect non-personal identification information about users whenever they interact with our site. 
            Non-personal identification information may include:
          </p>
          <ul>
            <li>Browser name</li>
            <li>Type of computer</li>
            <li>Technical information about users' means of connection to our site</li>
            <li>Operating system</li>
            <li>Internet service providers</li>
            <li>Other similar information</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We may use the information we collect from you for the following purposes:</p>
          <ul>
            <li>To personalize user experience</li>
            <li>To improve our website</li>
            <li>To process transactions</li>
            <li>To send periodic emails</li>
            <li>To administer promotions, surveys, or other site features</li>
            <li>To send information and updates pertaining to orders</li>
            <li>To respond to customer service requests</li>
            <li>To administer your account</li>
          </ul>
        </section>

        <section>
          <h2>4. Cookies</h2>
          <p>
            Our website uses "cookies" to enhance user experience. A cookie is a small piece of data stored on your 
            computer or mobile device by your web browser while you are browsing. Cookies may track, save, and store 
            information such as your preferences and the pages of our website that you have visited.
          </p>
          <p>
            You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off 
            all cookies through your browser settings. Since each browser is different, look at your browser's Help Menu to 
            learn the correct way to modify your cookies.
          </p>
          <p>
            If you disable cookies, some features may be disabled, and some of our services may not function properly.
          </p>
        </section>

        <section>
          <h2>5. Third-Party Disclosure</h2>
          <p>
            We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties unless 
            we provide users with advance notice. This does not include website hosting partners and other parties who assist 
            us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep 
            this information confidential.
          </p>
          <p>
            We may also release information when its release is appropriate to comply with the law, enforce our site policies, 
            or protect ours or others' rights, property, or safety.
          </p>
        </section>

        <section>
          <h2>6. Data Security</h2>
          <p>
            We implement a variety of security measures to maintain the safety of your personal information when you place an 
            order or enter, submit, or access your personal information. We use secure servers and encryption to protect your data.
          </p>
          <p>
            However, no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive 
            to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.
          </p>
        </section>

        <section>
          <h2>7. Your Rights</h2>
          <p>Under the General Data Protection Regulation (GDPR), you have the following rights:</p>
          <ul>
            <li>The right to access your personal data</li>
            <li>The right to rectification of inaccurate personal data</li>
            <li>The right to erasure of your personal data</li>
            <li>The right to restrict processing of your personal data</li>
            <li>The right to data portability</li>
            <li>The right to object to processing of your personal data</li>
            <li>The right not to be subject to automated decision-making</li>
          </ul>
          <p>
            To exercise any of these rights, please contact us using the information provided in the "Contact Us" section.
          </p>
        </section>

        <section>
          <h2>8. Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy 
            Policy on this page and updating the "Last Updated" date at the top of this page. You are advised to review this 
            Privacy Policy periodically for any changes.
          </p>
        </section>

        <section>
          <h2>9. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p>
            Email: privacy@tyrrst.com<br />
            Address: Tyrrst Headquarters, 123 Main Street, City, Country
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
